<template>
  <div class="row">
    <div class="col-12">
      <h4 class="text-green text-center">設定註解</h4>
      <form class="form">
        <div class="panel panel-form searchArea">
          <!-- 保障分類 -->
          <div class="form-group row">
            <label class="col-2 text-right">保障分類</label>
            <div class="col-10 d-inline-grid">
              <select
                id="parentItemId"
                class="form-control form-control-inline form-wide w-250"
                :class="{ 'is-invalid': isParentItemError }"
                v-model="form.parentItemId"
              >
                <option value="">請選擇</option>
                <option
                  v-for="item in coverageParentItems"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>

          <!-- 保障項目 -->
          <div class="form-group row">
            <label class="col-2 text-right">保障項目</label>
            <div class="col-10 d-inline-grid">
              <select
                class="form-control form-control-inline form-wide w-250"
                :class="{ 'is-invalid': isChildItemError }"
                v-model="form.childItemId"
              >
                <option value="">請選擇</option>
                <option
                  v-for="item in coverageChildItems"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>

          <!-- 備註內容 -->
          <div class="form-group row">
            <label class="col-2 text-right">備註內容</label>
            <div class="col-10 d-inline-grid">
              <textarea
                class="form-control"
                cols="30"
                rows="5"
                maxlength="1000"
                :class="{ 'is-invalid': isNoteError }"
                v-model="form.note"
              ></textarea>
            </div>
          </div>

          <div class="text-center">
            <button
              type="button"
              :disabled="!productData"
              @click="add()"
              class="btn btn-primary"
            >
              新增
            </button>
            <button
              type="button"
              class="btn btn-default"
              @click="cancelClick()"
            >
              取消
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="col-12 mt-40">
      <button
        type="button"
        class="btn btn-default"
        v-on:click="deleteAllClick()"
      >
        全部刪除
      </button>
      <button
        type="button"
        class="btn btn-default"
        v-on:click="multDeleteClick()"
      >
        刪除多筆
      </button>
    </div>
    <div class="col-12">
      <table class="table datatable">
        <thead>
          <tr>
            <th width="10" class="text-center">選取</th>
            <th width="90" class="text-center">刪除</th>
            <th width="80" class="text-center">建立者</th>
            <th width="200" class="text-center">建立時間</th>
            <th width="200" class="text-center">保障項目</th>
            <th width="400" class="text-center">備註</th>
          </tr>
        </thead>
        <tbody v-if="formularData.length">
          <tr v-for="(item, i) in formularData" :key="`formular-data-${i}`">
            <td class="text-center">
              <div class="checkbox radio-inline mr-0">
                <input
                  type="checkbox"
                  :id="`formular-${i}`"
                  v-model="formSeletcted"
                  :value="item.coverage_category_formula_notes_id"
                />
                <label :for="`formular-${i}`"></label>
              </div>
            </td>
            <td class="text-center">
              <button
                type="button"
                class="btn btn-primary btn-sm"
                v-on:click="
                  deleteClick(item.coverage_category_formula_notes_id)
                "
              >
                刪除
              </button>
            </td>
            <td>{{ item.creator_name }}</td>
            <td>{{ moment(item.created_date).format("YYYY-MM-DD") }}</td>
            <td>{{ item.category_name }}</td>
            <td v-html="item.notemessage"></td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td class="text-center" colspan="6">
              <h4 class="mb-3">查無保障公式備註資訊</h4>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getCoverageItems } from "@/service";
import { getCoverageNotes } from "@/service";
import { addCoverageNote } from "@/service";
import { deleteCoverageNotes } from "@/service";
import { deleteAllCoverageNote } from "@/service";
import moment from "moment";

export default {
  name: "SettingNotes",
  data() {
    return {
      formularData: [],
      coverages: [],
      form: {
        parentItemId: "",
        childItemId: "",
        note: "",
      },
      userInfo: this.$store.state.userInfo,
      isParentItemError: false,
      isChildItemError: false,
      isNoteError: false,
      productData: null,
      formSeletcted: [],
    };
  },
  created() {
    this.productData = JSON.parse(localStorage.productData);
    this.getCoverageItems();
    this.getCoverageNotes();
  },
  computed: {
    ...mapGetters(["BaseUrl"]),
    //保障分類列表
    coverageParentItems() {
      return this.coverages.filter((item) => !item.parent);
    },
    //保障項目列表
    coverageChildItems() {
      return this.coverages.filter(
        (item) => item.parent && item.parent === this.form.parentItemId
      );
    },
    //保障項目選擇名稱
    childItemName() {
      return this.coverages.filter(
        (item) => item.id === this.form.childItemId
      )[0].name;
    },
  },
  watch: {
    //監聽項目是否異動
    "form.parentItemId": {
      handler() {
        this.form.childItemId = "";
      },
    },
  },
  methods: {
    //重置表單資料
    resetForm() {
      this.form.parentItemId = "";
      this.form.childItemId = "";
      this.form.note = "";
    },
    //下拉選單資料
    getCoverageItems() {
      getCoverageItems().then((result) => {
        if (result.header && result.header.status == "200") {
          this.coverages = result.coverages;
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    //表單資料
    getCoverageNotes() {
      const req = {
        productId: this.productData.productId,
      };
      getCoverageNotes(this.userInfo.id, req).then((result) => {
        if (result.header && result.header.status == "200") {
          this.formularData = result.data;
          // 顯示換行符號
          this.formularData.forEach((item) => {
            item.notemessage = item.notemessage.replaceAll('\n','<br>')
          });
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    //點擊單個刪除
    deleteClick(id) {
      if (!confirm("確認要刪除此筆資料？")) return;
      const delArr = [id];
      this.delete(delArr);
    },
    //點擊多筆刪除
    multDeleteClick() {
      if (!this.formSeletcted || !this.formSeletcted.length) {
        this.$toast.info({ title: "無保障公式備註可刪除" });
        return;
      }
      if (!confirm("確認要刪除多筆資料？")) return;
      this.delete(this.formSeletcted);
      this.formSeletcted = [];
    },
    //全部刪除
    deleteAllClick() {
      if (!this.formularData || !this.formularData.length) {
        this.$toast.info({ title: "無保障公式備註可刪除" });
        return;
      }
      if (!confirm("確認要刪除所有資料？")) return;
      this.deleteAll();
    },
    //取消(重置表單值)
    cancelClick() {
      this.resetForm();
    },
    //新增
    add() {
      if (this.validateForm()) return;
      let Note
      // 編碼處理
      Note = this.form.note.replaceAll('%','%25')

      const req = {
        productId: this.productData.productId,
        categoryId: this.form.parentItemId,
        categoryName: this.childItemName.replaceAll("%", "％"),
        notemessage: Note.replaceAll("%", "％"),
        creatorName: this.userInfo.name,
        creatorId: this.userInfo.id,
      };
      addCoverageNote(this.userInfo.id, req).then((result) => {
        if (result.header && result.header.status == "200") {
          this.$toast.info({ title: "新增成功" });
          this.getCoverageNotes();
          this.resetForm();
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    //刪除
    delete(delArr) {
      const req = [];
      delArr.forEach((element) => {
        const obj = { noteId: element };
        req.push(obj);
      });
      deleteCoverageNotes(this.userInfo.id, req).then((result) => {
        if (result.header && result.header.status == "200") {
          this.$toast.info({ title: "刪除成功" });
          this.getCoverageNotes();
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    deleteAll() {
      const req = {
        productId: this.productData.productId,
      };
      deleteAllCoverageNote(this.userInfo.id, req).then((result) => {
        if (result.header && result.header.status == "200") {
          this.$toast.info({ title: "刪除全部成功" });
          this.getCoverageNotes();
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    //參數檢查
    validateForm() {
      let isError = false;
      this.isParentItemError = false;
      this.isChildItemError = false;
      this.isNoteError = false;

      if (!this.form.parentItemId) {
        isError = true;
        this.isParentItemError = true;
        this.$toast.info({ title: "[保障分類]選單必須選擇" });
      }
      if (!this.form.childItemId) {
        isError = true;
        this.isChildItemError = true;
        this.$toast.info({ title: "[保障項目]選單必須選擇" });
      }
      if (!this.form.note) {
        isError = true;
        this.isNoteError = true;
        this.$toast.info({ title: "[備註內容]欄位不得為空" });
      }

      return isError;
    },
  },
};
</script>
<style scoped>
.mt-40 {
  margin-top: 40px;
}
.fs-12 {
  font-size: 12px;
}
.mr-0 {
  margin-right: 0px !important;
}
.w-250 {
  width: 250px !important;
}
.searchArea {
  border-color: #027a39;
  border-width: 3px;
  background-color: white;
}
.d-inline-grid {
  display: inline-grid;
}
</style>
